import Landing from 'apps/landing';
import SetupWithPlan from 'apps/user/GetStarted/SetupWithPlan';
import Assets from 'apps/user/page/Dashboard/Assets';
import BankAssetBeneficiaryList from 'apps/user/page/Dashboard/Assets/AssetsTypes/Bank/BankAssetBeneficiaryList';
import BankAssetAllocation from 'apps/user/page/Dashboard/Assets/AssetsTypes/Bank/BankAssetAllocation';
import Beneficiary from 'apps/user/page/Dashboard/Beneficiary';
import AssignBankBeneficiary from 'apps/user/page/Dashboard/Beneficiary/Assign/AssignBankBeneficiary';
import AssignBondBeneficiary from 'apps/user/page/Dashboard/Beneficiary/Assign/AssignBondBeneficiary';
import AssignEmployeeBeneficiary from 'apps/user/page/Dashboard/Beneficiary/Assign/AssignEmployeeBeneficiary';
import AssignPensionBeneficiary from 'apps/user/page/Dashboard/Beneficiary/Assign/AssignPensionBeneficiary';
import AssignPhysicalBeneficiary from 'apps/user/page/Dashboard/Beneficiary/Assign/AssignPhysicalBeneficiary';
import AssignStockBeneficiary from 'apps/user/page/Dashboard/Beneficiary/Assign/AssignStockBeneficiary';
import BeneficiaryProfile from 'apps/user/page/Dashboard/Beneficiary/BeneficiaryProfile';
import Executors from 'apps/user/page/Dashboard/Executors';
import ExecutorsProfile from 'apps/user/page/Dashboard/Executors/ExecutorsProfile';
import Guardians from 'apps/user/page/Dashboard/Guardians';
import GuardiansProfile from 'apps/user/page/Dashboard/Guardians/GuardiansProfile';
import Home from 'apps/user/page/Dashboard/Home';
import Profile from 'apps/user/page/Dashboard/Settings';
import Trustees from 'apps/user/page/Dashboard/Trustees';
import TrusteesProfile from 'apps/user/page/Dashboard/Trustees/TrusteesProfile';
import WillSummary from 'apps/user/page/Dashboard/WillSummary';
import SpecialInstructions from 'apps/user/page/Dashboard/WillSummary/SpecialInstructions';
import WillSummaryPreview from 'apps/user/page/Dashboard/WillSummary/WillSummaryPreview';
import NotFound from 'apps/user/page/NotFound';
import CreateAccount from 'apps/user/page/create-account';
import OnBoarding from 'apps/user/page/on-boarding';
import SuccessfulPage from 'apps/user/page/on-boarding/SuccessfulPage';
import useNetwork from 'common/hooks/useNetwork';
import GetStartedLayout from 'layout/GetStartedLayout';
import LandpageLayout from 'layout/LandpageLayout';
import OnBoardingLayout from 'layout/OnBoardingLayout';
import ProtectedLayout from 'layout/ProtectedLayout';
import { useRoutes } from 'react-router-dom';
import BondAssetBeneficiaryList from 'apps/user/page/Dashboard/Assets/AssetsTypes/Bond/BondAssetBeneficiaryList';
import BondAssetAllocation from 'apps/user/page/Dashboard/Assets/AssetsTypes/Bond/BondAssetAllocation';
import PensionAssetAllocation from 'apps/user/page/Dashboard/Assets/AssetsTypes/Pension/PensionAssetAllocation';
import PensionAssetBeneficiaryList from 'apps/user/page/Dashboard/Assets/AssetsTypes/Pension/PensionAssetBeneficiaryList';
import StockAssetAllocation from 'apps/user/page/Dashboard/Assets/AssetsTypes/Stock/StockAssetAllocation';
import StockAssetBeneficiaryList from 'apps/user/page/Dashboard/Assets/AssetsTypes/Stock/StockAssetBeneficiaryList';
// import BenefitAssetAllocation from 'apps/user/page/Dashboard/Assets/AssetsTypes/Benefit/BenefitAssetAllocation';
// import BenefitAssetBeneficiaryList from 'apps/user/page/Dashboard/Assets/AssetsTypes/Benefit/BenefitAssetBeneficiaryList';
import PhysicalAssetAllocation from 'apps/user/page/Dashboard/Assets/AssetsTypes/Physical/PhysicalAssetAllocation';
import PhysicalAssetBeneficiaryList from 'apps/user/page/Dashboard/Assets/AssetsTypes/Physical/PhysicalAssetBeneficiaryList';
import SpouseChildren from 'apps/user/page/Dashboard/SpouseChildren';
import ChildrenProfile from 'apps/user/page/Dashboard/SpouseChildren/Children/ChildrenProfile';
import SpouseProfile from 'apps/user/page/Dashboard/SpouseChildren/Spouse/SpouseProfile';
import DashboardOnBoarding from 'apps/user/page/Dashboard/Onboarding';
import AddBeneficiary from 'apps/user/page/Dashboard/Beneficiary/AddBeneficiary';
import ManageTrustee from 'apps/user/page/Dashboard/Assets/Trustee/ManageTrustee';
import AssignTrustee from 'apps/user/page/Dashboard/Assets/Trustee/AssignTrustee';
import BasicInfo from 'apps/user/OnBoarding/BasicInfo';
import IdentificationType from 'apps/user/OnBoarding/IdentificationType';
import SpouseInfo from 'apps/user/OnBoarding/SpouseInfo';
import ChildrenInfo from 'apps/user/OnBoarding/ChildrenInfo';
import BankInfo from 'apps/user/OnBoarding/BankInfo';
import PensionAccountInfo from 'apps/user/OnBoarding/PensionAccountInfo';
import EmployeeBenefitInfo from 'apps/user/OnBoarding/EmployeeBenefitInfo';
import StockShareInfo from 'apps/user/OnBoarding/StockShareInfo';
import BondInfo from 'apps/user/OnBoarding/BondInfo';
import PhysicalAssetInfo from 'apps/user/OnBoarding/PhysicalAssetInfo';
import BeneficiaryInfo from 'apps/user/OnBoarding/BeneficiaryInfo';
import GuardianInfo from 'apps/user/OnBoarding/GuardianInfo';
import ExecutorInfo from 'apps/user/OnBoarding/ExecutorInfo';
import TrusteeInfo from 'apps/user/OnBoarding/TrusteeInfo';
import UpdateSpecialInstructions from 'apps/user/page/Dashboard/WillSummary/UpdateSpecialInstructions';
import PDF from 'apps/user/page/pdf';
import AdminLayout from 'layout/AdminLayout';
import Dashboard from 'apps/admin';
import Prospects from 'apps/admin/pages/Prospect';
import Customers from 'apps/admin/pages/Customer';
import ProspectDetails from 'apps/admin/pages/Prospect/ProspectDetails';
import CustomerDetails from 'apps/admin/pages/Customer/CustomerDetails';
import CustomerWillInfo from 'apps/admin/pages/Customer/CustomerWillInfo';
import PaymentList from 'apps/admin/pages/Customer/PaymentList';
import PaymentDetails from 'apps/admin/pages/Customer/PaymentDetails';
import Staff from 'apps/admin/pages/Staff';
import StaffDetail from 'apps/admin/pages/Staff/StaffDetail';
import CustomerWillSummary from 'apps/admin/pages/Customer/WillSumarry';
import AssignStaff from 'apps/admin/pages/Customer/AssignStaff';
import WillHistory from 'apps/admin/pages/Customer/WillSumarry/WillHistory';
import AgentList from 'apps/admin/pages/Prospect/AgentList';
import Notes from 'apps/admin/pages/Prospect/Notes';
import CreateNote from 'apps/admin/pages/Prospect/CreateNote';

const onBoardingFlowRoute = [
  {
    path: 'basic-info',
    index: true,
    element: <BasicInfo />
  },
  {
    path: 'identification',
    element: <IdentificationType />
  },
  {
    path: 'spouse-info',
    element: <SpouseInfo />
  },
  {
    path: 'children-info',
    element: <ChildrenInfo />
  },
  {
    path: 'bank-info',
    element: <BankInfo />
  },
  {
    path: 'pension-info',
    element: <PensionAccountInfo />
  },
  {
    path: 'employee-info',
    element: <EmployeeBenefitInfo />
  },
  {
    path: 'stock-share-info',
    element: <StockShareInfo />
  },
  {
    path: 'bond-info',
    element: <BondInfo />
  },
  {
    path: 'physical-asset-info',
    element: <PhysicalAssetInfo />
  },
  {
    path: 'beneficiary-info',
    element: <BeneficiaryInfo />
  },
  {
    path: 'guardian-info',
    element: <GuardianInfo />
  },
  {
    path: 'executor-info',
    element: <ExecutorInfo />
  },
  {
    path: 'trustee-info',
    element: <TrusteeInfo />
  }
];

const adminRoutes = [
  {
    path: '',
    children: [
      {
        path: '',
        index: true,
        element: <Dashboard />
      },
      {
        path: 'prospects',
        children: [
          {
            path: '',
            index: true,
            element: <Prospects />
          },
          {
            path: 'details/:prospectId',
            element: <ProspectDetails />
          },
          {
            path: 'assign-agent/:prospectId',
            element: <AgentList />
          },
          {
            path: 'notes/:prospectId',
            element: <Notes />
          },
          {
            path: 'create-note/:prospectId',
            element: <CreateNote />
          }
        ]
      },
      {
        path: 'customers',
        children: [
          {
            path: '',
            index: true,
            element: <Customers />
          },
          {
            path: 'details/:customerId',
            element: <CustomerDetails />
          },
          {
            path: 'will-info/:customerId',
            element: <CustomerWillInfo />
          },
          {
            path: 'will-summary/:customerId',
            element: <CustomerWillSummary />
          },
          {
            path: 'will-history/:customerId',
            element: <WillHistory />
          },
          {
            path: 'payments/:customerId',
            element: <PaymentList />
          },
          {
            path: 'payment-details/:customerId/:paymentId',
            element: <PaymentDetails />
          },
          {
            path: 'assign-staff/:customerId',
            element: <AssignStaff />
          }
        ]
      },
      {
        path: 'staff',
        children: [
          {
            path: '',
            index: true,
            element: <Staff />
          },
          {
            path: 'details/:staffId',
            element: <StaffDetail />
          }
        ]
      }
    ]
  }
];

const Routes = () => {
  useNetwork();

  return useRoutes([
    {
      path: '',
      element: <LandpageLayout />,
      children: [
        {
          path: '',
          index: true,
          element: <Landing />
        }
      ]
    },
    {
      path: 'get-started',
      element: <GetStartedLayout />,
      children: [
        {
          path: '',
          index: true,
          element: <CreateAccount />
        },
        {
          path: 'setup-account/:planId',
          element: <SetupWithPlan />
        }
      ]
    },
    {
      path: 'on-boarding',
      element: <OnBoardingLayout />,
      children: [
        {
          path: '',
          element: <OnBoarding />,
          children: onBoardingFlowRoute
        },
        {
          path: 'welcome',
          element: <SuccessfulPage />
        }
      ]
    },
    {
      path: 'dashboard',
      element: <ProtectedLayout />,
      children: [
        {
          path: '',
          children: [
            {
              path: '',
              index: true,
              element: <Home />
            },
            {
              path: 'onboarding',
              element: <DashboardOnBoarding />,
              children: onBoardingFlowRoute
            },
            {
              path: 'profile',
              element: <Profile />
            }
          ]
        },
        {
          path: 'assets',
          children: [
            {
              path: '',
              index: true,
              element: <Assets />
            },
            {
              path: 'trustee',
              children: [
                {
                  path: 'manage-trustee',
                  element: <ManageTrustee />
                },
                {
                  path: 'assign-trustee/:trusteeId',
                  element: <AssignTrustee />
                }
              ]
            },
            {
              path: 'bank',
              children: [
                {
                  path: 'details/:bankId',
                  element: <BankAssetAllocation />
                },
                {
                  path: 'beneficiary/:bankId',
                  element: <BankAssetBeneficiaryList />
                }
              ]
            },
            {
              path: 'bond',
              children: [
                {
                  path: 'details/:bondId',
                  element: <BondAssetAllocation />
                },
                {
                  path: 'beneficiary/:bondId',
                  element: <BondAssetBeneficiaryList />
                }
              ]
            },
            {
              path: 'pension',
              children: [
                {
                  path: 'details/:pensionId',
                  element: <PensionAssetAllocation />
                },
                {
                  path: 'beneficiary/:pensionId',
                  element: <PensionAssetBeneficiaryList />
                }
              ]
            },
            {
              path: 'stock',
              children: [
                {
                  path: 'details/:stockId',
                  element: <StockAssetAllocation />
                },
                {
                  path: 'beneficiary/:stockId',
                  element: <StockAssetBeneficiaryList />
                }
              ]
            },
            // {
            //   path: 'benefit',
            //   children: [
            //     {
            //       path: 'details/:benefitId',
            //       element: <BenefitAssetAllocation />
            //     },
            //     {
            //       path: 'beneficiary/:benefitId',
            //       element: <BenefitAssetBeneficiaryList />
            //     }
            //   ]
            // },
            {
              path: 'physical',
              children: [
                {
                  path: 'details/:physicalId',
                  element: <PhysicalAssetAllocation />
                },
                {
                  path: 'beneficiary/:physicalId',
                  element: <PhysicalAssetBeneficiaryList />
                }
              ]
            }
          ]
        },
        {
          path: 'beneficiary',
          children: [
            {
              path: '',
              index: true,
              element: <Beneficiary />
            },
            {
              path: 'add',
              element: <AddBeneficiary />
            },
            {
              path: 'assign',
              children: [
                {
                  path: 'bank',
                  element: <AssignBankBeneficiary />
                },
                {
                  path: 'stock',
                  element: <AssignStockBeneficiary />
                },
                {
                  path: 'pension',
                  element: <AssignPensionBeneficiary />
                },
                {
                  path: 'bond',
                  element: <AssignBondBeneficiary />
                },
                {
                  path: 'physical',
                  element: <AssignPhysicalBeneficiary />
                },
                {
                  path: 'employee',
                  element: <AssignEmployeeBeneficiary />
                }
              ]
            },
            {
              path: 'profile/:beneficiaryId',
              element: <BeneficiaryProfile />
            }
          ]
        },
        {
          path: 'spouse-children',
          children: [
            {
              path: '',
              index: true,
              element: <SpouseChildren />
            },
            {
              path: 'spouse-profile/:spouseId',
              element: <SpouseProfile />
            },
            {
              path: 'children-profile/:childrenId',
              element: <ChildrenProfile />
            }
          ]
        },
        {
          path: 'executors',
          children: [
            {
              path: '',
              index: true,
              element: <Executors />
            },
            {
              path: 'profile/:executorId',
              element: <ExecutorsProfile />
            }
          ]
        },
        {
          path: 'guardians',
          children: [
            {
              path: '',
              index: true,
              element: <Guardians />
            },
            {
              path: 'profile/:guardianId',
              element: <GuardiansProfile />
            }
          ]
        },
        {
          path: 'trustee',
          children: [
            {
              path: '',
              index: true,
              element: <Trustees />
            },
            {
              path: 'profile/:trusteeId',
              element: <TrusteesProfile />
            }
          ]
        },
        {
          path: 'will-summary',
          children: [
            {
              path: '',
              index: true,
              element: <WillSummary />
            },
            {
              path: 'special-instructions',
              element: <SpecialInstructions />
            },
            {
              path: 'update-special-instructions',
              element: <UpdateSpecialInstructions />
            },
            {
              path: 'preview',
              element: <WillSummaryPreview />
            }
          ]
        }
      ]
    },
    {
      path: 'admin',
      element: <AdminLayout />,
      children: adminRoutes
    },
    {
      path: 'pdf',
      element: <PDF />
    },
    {
      path: '*',
      element: <NotFound />
    }
  ]);
};

export default Routes;
